import React, { useContext } from 'react';
import { Col, Form, Row } from 'antd';
import tokens from '../../../../../../../../utils/tokens';
import DataForm from './DataForm';
import { EnrollmentFormContext } from '../../../../../../../../providers/EnrollmentFormContextProvider';
import form from '../../../../../../../../utils/form';
import EffectiveModalControl from '../PreviewUAFForm/EffectiveModalControl';

const EffectiveControlForm = () => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const gutter = tokens.forms.horizontalGutterInPx;

  return (
    <Form form={enrollmentForm} layout="vertical" validateMessages={form.validateMessages}>
      <Row>
        <Col className="declaringPersonForm__title" span={24}>
          <EffectiveModalControl />
        </Col>
        <Col>
          <p>
            Indicar controlador persona natural, siempre y cuando tenga{' '}
            <strong>menos del 10%</strong> de propiedad.
          </p>
        </Col>
      </Row>
      <DataForm gutter={gutter} />
    </Form>
  );
};

export default EffectiveControlForm;
